import { FC } from "react";
import { SwiperSlide } from "swiper/react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ProductSlider from "./ProductSlider";
import ProductCard from "./ProductCard";
import { Product } from "../types/product";

interface ProductCardCarouselProps {
  isMobile: boolean;
  sliderClassName: string;
  products: Product[];
  showMobilePagination?: boolean;
  desktopNavigationClassName?: string;
  mobileSpaceBetween?: number;
  desktopSpaceBetween?: number;
  mobileSlideClassName?: string;
  desktopSlideClassName?: string;
  mobileCardClassName?: string;
  desktopCardClassName?: string;
  skeletonCountMobile?: number;
  skeletonCountDesktop?: number;
}

const ProductCardCarousel: FC<ProductCardCarouselProps> = ({
  isMobile,
  sliderClassName,
  products,
  showMobilePagination = false,
  desktopNavigationClassName = "",
  mobileSpaceBetween = 12,
  desktopSpaceBetween = 5,
  mobileSlideClassName = "!w-[200px] !h-auto",
  desktopSlideClassName = "!w-[246px] !h-auto",
  mobileCardClassName = "h-full",
  desktopCardClassName = "h-full",
  skeletonCountMobile = 0,
  skeletonCountDesktop = 0,
}) => {
  const slideClassName = isMobile ? mobileSlideClassName : desktopSlideClassName;
  const cardClassName = isMobile ? mobileCardClassName : desktopCardClassName;
  const skeletonCount = isMobile ? skeletonCountMobile : skeletonCountDesktop;

  return (
    <ProductSlider
      isMobile={isMobile}
      spaceBetween={isMobile ? mobileSpaceBetween : desktopSpaceBetween}
      className={sliderClassName}
      showMobilePagination={showMobilePagination}
      desktopNavigationClassName={desktopNavigationClassName}
    >
      {products.length > 0
        ? products.map((product) => (
            <SwiperSlide key={product.artikul} className={slideClassName}>
              <ProductCard product={product} className={cardClassName} />
            </SwiperSlide>
          ))
        : Array.from({ length: skeletonCount }).map((_, idx) => (
            <SwiperSlide key={`product-skeleton-${idx}`} className={slideClassName}>
              <div className={!isMobile ? "p-[20px]" : "py-[20px] px-[10px]"}>
                <div
                  className={
                    !isMobile
                      ? "w-[210px] mb-[20px]"
                      : "w-full max-w-[185px] py-[12px] mx-auto"
                  }
                >
                  <Skeleton
                    height={isMobile ? 110 : 154}
                    width={isMobile ? 150 : 210}
                    baseColor="#f3f3f3"
                    highlightColor="#ecebeb"
                    className="rounded"
                  />
                  <div className="flex flex-col gap-2 mt-[10px]">
                    <Skeleton
                      width={isMobile ? 80 : 120}
                      height={16}
                      baseColor="#f3f3f3"
                      highlightColor="#ecebeb"
                    />
                    <Skeleton
                      width={isMobile ? "90%" : 180}
                      height={14}
                      baseColor="#f3f3f3"
                      highlightColor="#ecebeb"
                    />
                  </div>
                  <div className="flex flex-col mt-[20px] gap-2">
                    <Skeleton
                      width={120}
                      height={12}
                      baseColor="#f3f3f3"
                      highlightColor="#ecebeb"
                    />
                    <Skeleton
                      width={140}
                      height={12}
                      baseColor="#f3f3f3"
                      highlightColor="#ecebeb"
                    />
                  </div>
                </div>
                <div className="flex items-center justify-between mt-[12px]">
                  <Skeleton
                    width={70}
                    height={20}
                    baseColor="#f3f3f3"
                    highlightColor="#ecebeb"
                  />
                  <Skeleton
                    width={46}
                    height={47}
                    baseColor="#f3f3f3"
                    highlightColor="#ecebeb"
                  />
                </div>
                <div className="mt-[12px]">
                  <Skeleton
                    height={45}
                    baseColor="#f3f3f3"
                    highlightColor="#ecebeb"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
    </ProductSlider>
  );
};

export default ProductCardCarousel;
